let TREEDATA = {
  'name': 'Careers',
  'children': [
    {
      'name': 'Arts, entertainment and Sports',
      'children': [
        {
          'name': 'Arts, Visual and Performing',
          'children': [
            {
              'name': 'Actors',
              'size': 2000
            },
            {
              'name': 'Art Directors',
              'size': 2000
            },
            {
              'name': 'Choreographers',
              'size': 2000
            },
            {
              'name': 'Composers',
              'size': 2000
            },
            {
              'name': 'Craft Artists',
              'size': 2000
            },
            {
              'name': 'Dancers',
              'size': 2000
            },
            {
              'name': 'Directors',
              'size': 2000
            },
            {
              'name': 'Fashion Designers',
              'size': 2000
            },
            {
              'name': 'Fine Artists',
              'size': 2000
            },
            {
              'name': 'Floral Designers',
              'size': 2000
            },
            {
              'name': 'Graphic Designers',
              'size': 2000
            },
            {
              'name': 'Illustrators',
              'size': 2000
            },
            {
              'name': 'Industrial Designers',
              'size': 2000
            },
            {
              'name': 'Interior Designers',
              'size': 2000
            },
            {
              'name': 'Multimedia Artists and Animators',
              'size': 2000
            },
            {
              'name': 'Musicians and Singers',
              'size': 2000
            },
            {
              'name': 'Photographers',
              'size': 2000
            },
            {
              'name': 'Set Designers',
              'size': 2000
            },
            {
              'name': 'Theater, Film, and TV Technicians',
              'size': 2000
            },
            {
              'name': 'Web Designers',
              'size': 2000
            }
          ]
        },
        {
          'name': 'Sports and Fitness',
          'children': [
            {
              'name': 'Coaches and Scouts',
              'size': 2000
            },
            {
              'name': 'Recreation and Fitness Workers',
              'size': 2000
            },
            {
              'name': 'Umpires and Referees',
              'size': 2000
            }
          ]
        }
      ]
    },
    {
      'name': 'Health and Medicine',
      'children': [
        {
          'name': 'Health Care Support',
          'children': [
            {
              'name': 'Dental Assistants',
              'size': 2000
            },
            {
              'name': 'Massage Therapists',
              'size': 2000
            },
            {
              'name': 'Medical Assistants',
              'size': 2000
            },
            {
              'name': 'Medical Transcriptionists',
              'size': 2000
            },
            {
              'name': 'Nursing, Psychiatric, and Home Health Aides',
              'size': 2000
            },
            {
              'name': 'Occupational Therapist Assistants',
              'size': 2000
            },
            {
              'name': 'Physical Therapist Assistants',
              'size': 2000
            },
            {
              'name': 'Speech-Language Pathology Assistants',
              'size': 2000
            }
          ]
        },
        {
          'name': 'Health Diagnosis and Treatment',
          'children': [
            {
              'name': 'Anesthesiologists',
              'size': 2000
            },
            {
              'name': 'Chiropractors',
              'size': 2000
            },
            {
              'name': 'Dentists',
              'size': 2000
            },
            {
              'name': 'Dietitians and Nutritionists',
              'size': 2000
            },
            {
              'name': 'General Practitioners',
              'size': 2000
            },
            {
              'name': 'Gynecologists and Obstetricians',
              'size': 2000
            },
            {
              'name': 'Internists',
              'size': 2000
            },
            {
              'name': 'Occupational Therapists',
              'size': 2000
            },
            {
              'name': 'Optometrists',
              'size': 2000
            },
            {
              'name': 'Pathologists',
              'size': 2000
            },
            {
              'name': 'Pediatricians',
              'size': 2000
            },
            {
              'name': 'Pharmacists',
              'size': 2000
            },
            {
              'name': 'Physical Therapists',
              'size': 2000
            },
            {
              'name': 'Physician Assistants',
              'size': 2000
            },
            {
              'name': 'Podiatrists',
              'size': 2000
            },
            {
              'name': 'Psychiatrists',
              'size': 2000
            },
            {
              'name': 'Radiation Therapists',
              'size': 2000
            },
            {
              'name': 'Radiologists',
              'size': 2000
            },
            {
              'name': 'Recreational Therapists',
              'size': 2000
            },
            {
              'name': 'Registered Nurses',
              'size': 2000
            },
            {
              'name': 'Respiratory Therapists',
              'size': 2000
            },
            {
              'name': 'Speech-Language Pathologists and Audiologists',
              'size': 2000
            },
            {
              'name': 'Surgeons',
              'size': 2000
            },
            {
              'name': 'Veterinarians',
              'size': 2000
            }
          ]
        },
        {
          'name': 'Health Technology',
          'children': [
            {
              'name': 'Athletic Trainers',
              'size': 2000
            },
            {
              'name': 'Dental Hygienists',
              'size': 2000
            },
            {
              'name': 'Diagnostic Medical Sonographers',
              'size': 2000
            },
            {
              'name': 'Dietetic Technicians',
              'size': 2000
            },
            {
              'name': 'Emergency Medical Technicians and Paramedics',
              'size': 2000
            },
            {
              'name': 'Health Information Technicians',
              'size': 2000
            },
            {
              'name': 'Licensed Practical Nurses',
              'size': 2000
            },
            {
              'name': 'Medical Billers and Coders',
              'size': 2000
            },
            {
              'name': 'Nuclear Medicine Technologists',
              'size': 2000
            },
            {
              'name': 'Occupational Health and Safety Specialists',
              'size': 2000
            },
            {
              'name': 'Opticians, Dispensing',
              'size': 2000
            },
            {
              'name': 'Pharmacy Technicians',
              'size': 2000
            },
            {
              'name': 'Radiologic Technologists',
              'size': 2000
            },
            {
              'name': 'Surgical Technologists',
              'size': 2000
            },
            {
              'name': 'Veterinary Technologists and Technicians',
              'size': 2000
            }
          ]
        }
      ]
    },
    {
      'name': 'Media and Social Sciences',
      'children': [
        {
          'name': 'Media and Communications',
          'children': [
            {
              'name': 'Camera Operators and Film and Video Editors',
              'size': 2000
            },
            {
              'name': 'Copy Editors',
              'size': 2000
            },
            {
              'name': 'Copywriters',
              'size': 2000
            },
            {
              'name': 'Editors',
              'size': 2000
            },
            {
              'name': 'Interpreters',
              'size': 2000
            },
            {
              'name': 'News Analysts, Reporters, and Correspondents',
              'size': 2000
            },
            {
              'name': 'Program Directors',
              'size': 2000
            },
            {
              'name': 'Public Relations Specialists',
              'size': 2000
            },
            {
              'name': 'Technical Writers',
              'size': 2000
            },
            {
              'name': 'Translators',
              'size': 2000
            },
            {
              'name': 'Writers',
              'size': 2000
            }
          ]
        },
        {
          'name': 'Social Science',
          'children': [
            {
              'name': 'Clinical Psychologists',
              'size': 2000
            },
            {
              'name': 'Economists',
              'size': 2000
            },
            {
              'name': 'Geographers',
              'size': 2000
            },
            {
              'name': 'Historians',
              'size': 2000
            },
            {
              'name': 'Industrial Psychologists',
              'size': 2000
            },
            {
              'name': 'Market and Survey Researchers',
              'size': 2000
            },
            {
              'name': 'Political Scientists',
              'size': 2000
            },
            {
              'name': 'Research Psychologists',
              'size': 2000
            },
            {
              'name': 'School Psychologists',
              'size': 2000
            },
            {
              'name': 'Sociologists',
              'size': 2000
            },
            {
              'name': 'Urban and Regional Planners',
              'size': 2000
            }
          ]
        }
      ]
    },
    {
      'name': 'Business',
      'children': [
        {
          'name': 'Business and Finance',
          'children': [
            {
              'name': 'Budget Analysts',
              'size': 2000
            },
            {
              'name': 'Claims Adjusters, Examiners, and Investigators',
              'size': 2000
            },
            {
              'name': 'Cost Estimators',
              'size': 2000
            },
            {
              'name': 'Financial Analysts',
              'size': 2000
            },
            {
              'name': 'Government Accountants and Auditors',
              'size': 2000
            },
            {
              'name': 'Insurance Underwriters',
              'size': 2000
            },
            {
              'name': 'Loan Officers and Counselors',
              'size': 2000
            },
            {
              'name': 'Management Accountants and Internal Auditors',
              'size': 2000
            },
            {
              'name': 'Meeting and Convention Planners',
              'size': 2000
            },
            {
              'name': 'Personal Financial Advisors',
              'size': 2000
            },
            {
              'name': 'Public Accountants',
              'size': 2000
            },
            {
              'name': 'Real Estate Appraisers',
              'size': 2000
            },
            {
              'name': 'Tax Examiners, Collectors, and Revenue Agents',
              'size': 2000
            },
            {
              'name': 'Management',
              'size': 2000
            }
          ]
        },
        {
          'name': 'Management',
          'children': [
            {
              'name': 'Administrative Services Managers',
              'size': 2000
            },
            {
              'name': 'Advertising, Marketing, and Public Relations Managers',
              'size': 2000
            },
            {
              'name': 'Arts Administrators',
              'size': 2000
            },
            {
              'name': 'Computer and Information Systems Managers',
              'size': 2000
            },
            {
              'name': 'Construction Managers',
              'size': 2000
            },
            {
              'name': 'Education Administrators',
              'size': 2000
            },
            {
              'name': 'Engineering and Science Managers',
              'size': 2000
            },
            {
              'name': 'Financial Managers',
              'size': 2000
            },
            {
              'name': 'Food Service Managers',
              'size': 2000
            },
            {
              'name': 'Funeral Directors',
              'size': 2000
            },
            {
              'name': 'Human Resources Managers',
              'size': 2000
            },
            {
              'name': 'Industrial Production Managers',
              'size': 2000
            },
            {
              'name': 'Labor Relations Managers',
              'size': 2000
            },
            {
              'name': 'Lodging Managers',
              'size': 2000
            },
            {
              'name': 'Management Consultants',
              'size': 2000
            },
            {
              'name': 'Medical and Health Services Managers',
              'size': 2000
            },
            {
              'name': 'Property Managers',
              'size': 2000
            },
            {
              'name': 'Top Executives',
              'size': 2000
            }
          ]
        },
        {
          'name': 'Office and Administrative Support',
          'children': [
            {
              'name': 'Brokerage Clerks',
              'size': 2000
            },
            {
              'name': 'Computer Operators',
              'size': 2000
            },
            {
              'name': 'Desktop Publishers',
              'size': 2000
            },
            {
              'name': 'Eligibility Interviewers',
              'size': 2000
            },
            {
              'name': 'Financial Clerks',
              'size': 2000
            },
            {
              'name': 'General Office Clerks',
              'size': 2000
            },
            {
              'name': 'Human Resources Assistants',
              'size': 2000
            },
            {
              'name': 'Reservation and Transportation Ticket Agents and Travel Clerks',
              'size': 2000
            }
          ]
        },
        {
          'name': 'Sales',
          'children': [
            {
              'name': 'Advertising Sales Agents',
              'size': 2000
            },
            {
              'name': 'Insurance Sales Agents',
              'size': 2000
            },
            {
              'name': 'Real Estate Brokers and Sales Agents',
              'size': 2000
            },
            {
              'name': 'Sales Engineers',
              'size': 2000
            },
            {
              'name': 'Sales Representatives, Wholesale and Manufacturing',
              'size': 2000
            },
            {
              'name': 'Sales Worker Supervisors',
              'size': 2000
            },
            {
              'name': 'Stockbrokers and Financial Services Sales Agents',
              'size': 2000
            },
            {
              'name': 'Travel Agents',
              'size': 2000
            }
          ]
        }
      ]
    },
    {
      'name': 'Public and Social Services',
      'children': [
        {
          'name': 'Community and Social Services',
          'children': [
            {
              'name': 'Child, Family, and School Social Workers',
              'size': 2000
            },
            {
              'name': 'Educational, Vocational, and School Counselors',
              'size': 2000
            },
            {
              'name': 'Health Educators',
              'size': 2000
            },
            {
              'name': 'Human-Service Assistants',
              'size': 2000
            },
            {
              'name': 'Marriage and Family Therapists',
              'size': 2000
            },
            {
              'name': 'Medical and Public Health Social Workers',
              'size': 2000
            },
            {
              'name': 'Mental Health and Substance Abuse Social Workers',
              'size': 2000
            },
            {
              'name': 'Mental Health Counselors',
              'size': 2000
            },
            {
              'name': 'Probation Officers and Correctional Treatment Specialists',
              'size': 2000
            },
            {
              'name': 'Protestant Ministers',
              'size': 2000
            },
            {
              'name': 'Rehabilitation Counselors',
              'size': 2000
            }
          ]
        },
        {
          'name': 'Education, Museum Work, and Library Science',
          'children': [
            {
              'name': 'Archivists',
              'size': 2000
            },
            {
              'name': 'Conservators',
              'size': 2000
            },
            {
              'name': 'Curators',
              'size': 2000
            },
            {
              'name': 'Elementary, Middle, and High School Teachers',
              'size': 2000
            },
            {
              'name': 'Exhibit Designers and Museum Technicians',
              'size': 2000
            },
            {
              'name': 'Instructional Coordinators',
              'size': 2000
            },
            {
              'name': 'Librarians',
              'size': 2000
            },
            {
              'name': 'Library Technicians',
              'size': 2000
            },
            {
              'name': 'Postsecondary Teachers',
              'size': 2000
            },
            {
              'name': 'Preschool Teachers',
              'size': 2000
            },
            {
              'name': 'Special Education Teachers',
              'size': 2000
            },
            {
              'name': 'Teacher Assistants',
              'size': 2000
            },
            {
              'name': 'Trainers',
              'size': 2000
            }
          ]
        },
        {
          'name': 'Law and Government',
          'children': [
            {
              'name': 'Court Reporters',
              'size': 2000
            },
            {
              'name': 'Foreign Service Officers',
              'size': 2000
            },
            {
              'name': 'Government Executives and Legislators',
              'size': 2000
            },
            {
              'name': 'Government Lawyers',
              'size': 2000
            },
            {
              'name': 'In-House Lawyers',
              'size': 2000
            },
            {
              'name': 'Judges',
              'size': 2000
            },
            {
              'name': 'Paralegals',
              'size': 2000
            },
            {
              'name': 'Private-Practice Lawyers',
              'size': 2000
            },
            {
              'name': 'Public Interest Advocates',
              'size': 2000
            },
            {
              'name': 'Public Interest Lawyers',
              'size': 2000
            }
          ]
        },
        {
          'name': 'Protective Services',
          'children': [
            {
              'name': 'Correctional Officers',
              'size': 2000
            },
            {
              'name': 'Detectives',
              'size': 2000
            },
            {
              'name': 'Federal Agents',
              'size': 2000
            },
            {
              'name': 'Firefighters',
              'size': 2000
            },
            {
              'name': 'Forensic Scientists',
              'size': 2000
            },
            {
              'name': 'Police Officers',
              'size': 2000
            },
            {
              'name': 'Private Detectives',
              'size': 2000
            },
            {
              'name': 'Security Guards',
              'size': 2000
            }
          ]
        }
      ]
    },
    {
      'name': 'Science, Math and Technology',
      'children': [
        {
          'name': 'Architecture, Engineering, and Drafting',
          'children': [
            {
              'name': 'Aerospace Engineers',
              'size': 2000
            },
            {
              'name': 'Agricultural Engineers',
              'size': 2000
            },
            {
              'name': 'Architects',
              'size': 2000
            },
            {
              'name': 'Biomedical Engineers',
              'size': 2000
            },
            {
              'name': 'Chemical Engineers',
              'size': 2000
            },
            {
              'name': 'Civil Engineers',
              'size': 2000
            },
            {
              'name': 'Computer Hardware Engineers',
              'size': 2000
            },
            {
              'name': 'Drafters',
              'size': 2000
            },
            {
              'name': 'Electrical Engineers',
              'size': 2000
            },
            {
              'name': 'Engineering Technicians',
              'size': 2000
            },
            {
              'name': 'Environmental Engineers',
              'size': 2000
            },
            {
              'name': 'Geographic Specialists',
              'size': 2000
            },
            {
              'name': 'Industrial Engineers',
              'size': 2000
            },
            {
              'name': 'Landscape Architects',
              'size': 2000
            },
            {
              'name': 'Materials Engineers',
              'size': 2000
            },
            {
              'name': 'Mechanical Engineers',
              'size': 2000
            },
            {
              'name': 'Mining and Geological Engineers',
              'size': 2000
            },
            {
              'name': 'Nuclear Engineers',
              'size': 2000
            },
            {
              'name': 'Petroleum Engineers',
              'size': 2000
            }
          ]
        },
        {
          'name': 'Computers and Math',
          'children': [
            {
              'name': 'Actuaries',
              'size': 2000
            },
            {
              'name': 'Computer Programmers',
              'size': 2000
            },
            {
              'name': 'Computer Scientists',
              'size': 2000
            },
            {
              'name': 'Software Developers',
              'size': 2000
            },
            {
              'name': 'Computer Support Specialists',
              'size': 2000
            },
            {
              'name': 'Computer Systems Analysts',
              'size': 2000
            },
            {
              'name': 'Database Administrators',
              'size': 2000
            },
            {
              'name': 'Mathematicians',
              'size': 2000
            },
            {
              'name': 'Network and Computer Systems Administrators',
              'size': 2000
            },
            {
              'name': 'Network Systems and Data Communications Analysts',
              'size': 2000
            },
            {
              'name': 'Operations Research Analysts',
              'size': 2000
            },
            {
              'name': 'Statisticians',
              'size': 2000
            }
          ]
        },
        {
          'name': 'Environment',
          'children': [
            {
              'name': 'Conservation Scientists',
              'size': 2000
            },
            {
              'name': 'Environmental Educators',
              'size': 2000
            },
            {
              'name': 'Environmental Inspectors',
              'size': 2000
            },
            {
              'name': 'Environmental Scientists',
              'size': 2000
            },
            {
              'name': 'Foresters and Forestry Technicians',
              'size': 2000
            },
            {
              'name': 'Park Rangers',
              'size': 2000
            },
            {
              'name': 'Preserve Managers',
              'size': 2000
            },
            {
              'name': 'Water- and Wastewater-Treatment-Plant Operators',
              'size': 2000
            },
            {
              'name': 'Wildlife Technicians',
              'size': 2000
            }
          ]
        },
        {
          'name': 'Science',
          'children': [
            {
              'name': 'Agricultural and Food Scientists',
              'size': 2000
            },
            {
              'name': 'Biological Scientists',
              'size': 2000
            },
            {
              'name': 'Chemists and Materials Scientists',
              'size': 2000
            },
            {
              'name': 'Geoscientists',
              'size': 2000
            },
            {
              'name': 'Medical Scientists',
              'size': 2000
            },
            {
              'name': 'Meteorologists',
              'size': 2000
            },
            {
              'name': 'Physicists and Astronomers',
              'size': 2000
            },
            {
              'name': 'Science Technicians',
              'size': 2000
            }
          ]
        }
      ]
    },
    {
      'name': 'Trades and Personal Services',
      'children': [
        {
          'name': 'Construction',
          'children': [
            {
              'name': 'Boilermakers',
              'size': 2000
            },
            {
              'name': 'Bricklayers and Stonemasons',
              'size': 2000
            },
            {
              'name': 'Carpenters',
              'size': 2000
            },
            {
              'name': 'Cement Masons and Concrete Finishers',
              'size': 2000
            },
            {
              'name': 'Construction and Building Inspectors',
              'size': 2000
            },
            {
              'name': 'Construction Equipment Operators',
              'size': 2000
            },
            {
              'name': 'Construction Laborers',
              'size': 2000
            },
            {
              'name': 'Drywall Workers',
              'size': 2000
            },
            {
              'name': 'Electricians',
              'size': 2000
            },
            {
              'name': 'Elevator Installers and Repairers',
              'size': 2000
            },
            {
              'name': 'Glaziers',
              'size': 2000
            },
            {
              'name': 'Hazardous Materials Removal Workers',
              'size': 2000
            },
            {
              'name': 'Insulation Workers',
              'size': 2000
            },
            {
              'name': 'Ironworkers',
              'size': 2000
            },
            {
              'name': 'Painters and Paperhangers',
              'size': 2000
            },
            {
              'name': 'Plasterers',
              'size': 2000
            },
            {
              'name': 'Plumbers',
              'size': 2000
            },
            {
              'name': 'Roofers',
              'size': 2000
            },
            {
              'name': 'Sheet Metal Workers',
              'size': 2000
            }
          ]
        },
        {
          'name': 'Installation and Repair',
          'children': [
            {
              'name': 'Aircraft and Avionics Technicians',
              'size': 2000
            },
            {
              'name': 'ATM Technicians',
              'size': 2000
            },
            {
              'name': 'Automotive Technicians',
              'size': 2000
            },
            {
              'name': 'Automotive-Body Repairers',
              'size': 2000
            },
            {
              'name': 'Computer-Repair Technicians',
              'size': 2000
            },
            {
              'name': 'Consumer Electronics Technicians',
              'size': 2000
            },
            {
              'name': 'Diesel Technicians',
              'size': 2000
            },
            {
              'name': 'Electronics Technicians',
              'size': 2000
            },
            {
              'name': 'Farm Equipment Mechanics',
              'size': 2000
            },
            {
              'name': 'Heating, Ventilation, Air-Conditioning, and Refrigeration Technicians',
              'size': 2000
            },
            {
              'name': 'Heavy Vehicle and Mobile Equipment Technicians',
              'size': 2000
            },
            {
              'name': 'Home Appliance Repairers',
              'size': 2000
            },
            {
              'name': 'Industrial Machinery Repairers',
              'size': 2000
            },
            {
              'name': 'Line Installers and Repairers',
              'size': 2000
            },
            {
              'name': 'Office Machine Technicians',
              'size': 2000
            },
            {
              'name': 'Precision Instrument and Equipment Repairers',
              'size': 2000
            },
            {
              'name': 'Small Engine Mechanics',
              'size': 2000
            },
            {
              'name': 'Telecommunications and Radio Technicians',
              'size': 2000
            }
          ]
        },
        {
          'name': 'Personal Care and Culinary Services',
          'children': [
            {
              'name': 'Animal Caretakers',
              'size': 2000
            },
            {
              'name': 'Barbers and Hairstylists',
              'size': 2000
            },
            {
              'name': 'Chefs',
              'size': 2000
            },
            {
              'name': 'Child Care Workers',
              'size': 2000
            },
            {
              'name': 'Flight Attendants',
              'size': 2000
            },
            {
              'name': 'Landscapers and Groundskeepers',
              'size': 2000
            },
            {
              'name': 'Personal and Home Care Aides',
              'size': 2000
            }
          ]
        },
        {
          'name': 'Production',
          'children': [
            {
              'name': 'Computer-Control Programmers and Operators',
              'size': 2000
            },
            {
              'name': 'Dental Laboratory Technicians',
              'size': 2000
            },
            {
              'name': 'Jewelers and Precious Stone and Metal Workers',
              'size': 2000
            },
            {
              'name': 'Machinists',
              'size': 2000
            },
            {
              'name': 'Printing-Machine Operators',
              'size': 2000
            },
            {
              'name': 'Semiconductor Processors',
              'size': 2000
            },
            {
              'name': 'Stationary Engineers and Boiler Operators',
              'size': 2000
            },
            {
              'name': 'Tool and Die Makers',
              'size': 2000
            },
            {
              'name': 'Welders',
              'size': 2000
            }
          ]
        },
        {
          'name': 'Transportation',
          'children': [
            {
              'name': 'Aircraft Pilots',
              'size': 2000
            },
            {
              'name': 'Air Traffic Controllers',
              'size': 2000
            },
            {
              'name': 'Locomotive Engineers',
              'size': 2000
            },
            {
              'name': 'Railroad Conductors',
              'size': 2000
            },
            {
              'name': 'Ship Captains and Marine Pilots',
              'size': 2000
            },
            {
              'name': 'Ship Engineers',
              'size': 2000
            }
          ]
        }
      ]
    }
  ]
}

export { TREEDATA }



// WEBPACK FOOTER //
// ./src/treeStaticData.js